import { render, staticRenderFns } from "./SimpleStatCard.vue?vue&type=template&id=68c33489&scoped=true&"
import script from "./SimpleStatCard.vue?vue&type=script&lang=js&"
export * from "./SimpleStatCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleStatCard.vue?vue&type=style&index=0&id=68c33489&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c33489",
  null
  
)

export default component.exports